/**************************************************
 * Nombre:       Tarjeta_Banner
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import perro from '../../Recursos/tmp_banner.png'
import {theme} from "../../Tema";
import {KeyboardArrowRight} from "@mui/icons-material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";


const Tarjeta_Banner = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontSize: !masSM ? 14 : 16,
                                    fontWeight: 700,
                                    color: theme.palette.secondary.main,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>{item?.subTituloUno}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                            <Typography sx={{
                                fontSize: !masSM ? 48 : 64,
                                fontWeight: 800,
                                color: theme.palette.primary.main,
                                lineHeight: 1.1,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                {item?.nombre}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}>
                            <Typography sx={{
                                fontSize: 18,
                                fontWeight: 700,
                                color: theme.palette.primary.main,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                {item?.subTituloDos}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4}}>
                            {item.textoBoton &&
                                <Button
                                    onClick={() => irUrl(item.link)}
                                    color={'secondary'} sx={{px: 1, py: 0.8}}>
                                    <Typography sx={{px: 2, fontSize: 14}}>
                                        {item.textoBoton ? item.textoBoton : ''}
                                    </Typography>
                                    <IconButton
                                        sx={{
                                            backgroundColor: '#fff',
                                            p: 0.6
                                        }}><KeyboardArrowRight/></IconButton></Button>
                            }
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'center'}}>
                    <img src={perro} width={'64%'} height={'auto'}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Banner    